module.exports = __webpack_public_path__ + "static/media/zoleWon_10000_25000.504398e4.png";